/** App-wide Roboto font stacks (mobile view). Devanagari fallback matches MT5 Hindi. */
export const FONT_ROBOTO =
  'Roboto, "Noto Sans Devanagari", "Nirmala UI", "Mangal", sans-serif';
export const FONT_ROBOTO_MONO = "Roboto Mono, monospace";
